import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert2";
import { useAgents } from "../../contexts/AgentsContext";
import { AppContext } from "../../contexts/AppContext";
import AgentsTable from "../../components/Tables/AgentsTable";
import GenerateWorkflowDialog from "../../components/Workflows/GenerateWorkflowDialog";
import { extractGeneratedGraph } from "../../services/workflowGeneration";
import { Button } from "../../components/StyledElements";

export const AgentsList = ({ show = false }) => {
  const { agents } = useAgents();
  const { selectedClient } = useContext(AppContext);
  const [showGenerateDialog, setShowGenerateDialog] = useState(false);
  const navigate = useNavigate();

  const handleGenerated = async (saved, results) => {
    setShowGenerateDialog(false);
    const publicId = saved?.public_id;

    if (!publicId) {
      swal.fire({
        title: "Generated",
        text: "The workflow was generated but no workflow id came back.",
        icon: "info",
      });
      return;
    }

    const result = await swal.fire({
      title: "Workflow generated",
      text: `"${saved?.name ?? "Workflow"}" was created. Open it in the workflow editor?`,
      icon: "success",
      showCancelButton: true,
      confirmButtonText: "Open workflow",
      cancelButtonText: "Close",
    });

    if (result.isConfirmed) {
      // Hand the generated graph over so the editor can show it even if the saved record
      // cannot be read back from the workflow endpoints.
      navigate(`/workflow/${publicId}`, {
        state: { graph: extractGeneratedGraph(results), name: saved?.name ?? null },
      });
    }
  };

  return (
    <div style={{ width: "100%", display: show ? "flex" : "none", flexDirection: "column", boxSizing: "border-box", gap: "10px" }}>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
        <div style={{ fontSize: "13px", color: "#a0a6b1", flex: 1 }}>
          Turn a plain-language description into a workflow you can attach to an agent.
        </div>
        <Button onClick={() => setShowGenerateDialog(true)}>Generate workflow</Button>
      </div>

      <AgentsTable agents={agents} />

      <GenerateWorkflowDialog
        show={showGenerateDialog}
        onClose={() => setShowGenerateDialog(false)}
        onGenerated={handleGenerated}
        clientId={selectedClient?.public_id ?? selectedClient?.id ?? null}
      />
    </div>
  );
};

export default AgentsList;
